import { render, staticRenderFns } from "./double-image-hero.vue?vue&type=template&id=c37695dc&scoped=true&"
import script from "./double-image-hero.vue?vue&type=script&lang=js&"
export * from "./double-image-hero.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=c37695dc&scoped=true&lang=css&"
import style1 from "./double-image-hero.vue?vue&type=style&index=1&id=c37695dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37695dc",
  null
  
)

export default component.exports